// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__YBch5","savePackageButton":"ClientWallet_savePackageButton__3W1V4"};